import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardAnesthesiaStatReportUX = (props: any) => {
    return(
      <div
        id="CardAnesthesiaStatReportUX-div-0"
        style={{position: "relative", padding: "1rem"}}>
        <div
          id="CardAnesthesiaStatReportUX-div-1">
          
          <Form
            id="CardAnesthesiaStatReportUX-Form-2">
            <FormGroup
              id="CardAnesthesiaStatReportUX-FormGroup-3"
              inline={true}
              style={{display: "flex"}}>
              <FormField
                id="CardAnesthesiaStatReportUX-FormField-4">
                <div
                  id="CardAnesthesiaStatReportUX-div-8">
                  วันที่เริ่มดมยา
                </div>
              </FormField>
              <FormField
                id="CardAnesthesiaStatReportUX-FormField-6">
                <div
                  id="CardAnesthesiaStatReportUX-div-14">
                  
                  <DateTextBox
                    id="CardAnesthesiaStatReportUX-DateTextBox-7"
                    onChange={(date: string) => props.onHandleChangeDate("filterStartDate", date)}
                    value={props.startDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardAnesthesiaStatReportUX-FormField-9">
                <div
                  id="CardAnesthesiaStatReportUX-div-10">
                  ถึง
                </div>
              </FormField>
              <FormField
                id="CardAnesthesiaStatReportUX-FormField-11">
                <div
                  id="CardAnesthesiaStatReportUX-div-15">
                  
                  <DateTextBox
                    id="CardAnesthesiaStatReportUX-DateTextBox-12"
                    onChange={(date: string) => props.onHandleChangeDate("filterEndDate", date)}
                    value={props.endDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardAnesthesiaStatReportUX-FormField-16">
                <div
                  id="CardAnesthesiaStatReportUX-div-17">
                  
                  <div
                    id="CardAnesthesiaStatReportUX-div-32">
                    {props.searchButtonLoadCheck}
                  </div>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAnesthesiaStatReportUX-FormGroup-19"
              inline={true}
              style={{display: "flex", padding: "2rem 0rem 1rem 0rem"}}>
              <FormField
                id="CardAnesthesiaStatReportUX-FormField-20"
                width={8}>
                <div
                  id="CardAnesthesiaStatReportUX-div-22"
                  style={{width: "100%", display: "flex", justifyContent: "flex-start", gap: "1rem"}}>
                  
                  <label
                    id="CardAnesthesiaStatReportUX-label-24"
                    style={{display: "flex", alignItems: "center"}}>
                    แสดงผลลัพธ์การค้นหา
                  </label>
                  <label
                    id="CardAnesthesiaStatReportUX-label-25"
                    style={{display: "flex", alignItems: "center", fontSize: "22px", color: "darkcyan"}}>
                    {props.searchCount}
                  </label>
                  <label
                    id="CardAnesthesiaStatReportUX-label-26"
                    style={{display: "flex", alignItems: "center"}}>
                    รายการ
                  </label>
                  <div
                    id="CardAnesthesiaStatReportUX-div-33">
                    {props.exportButtonLoadCheck}
                  </div>
                </div>
              </FormField>
              <FormField
                id="CardAnesthesiaStatReportUX-FormField-21"
                width={8}>
                <div
                  id="CardAnesthesiaStatReportUX-div-23"
                  style={{width: "100%", display: "flex", justifyContent: "flex-end", gap: "1rem"}}>
                  
                  <label
                    id="CardAnesthesiaStatReportUX-label-27"
                    style={{display: "flex", alignItems: "center"}}>
                    เลือกประเภทสถิติ
                  </label>
                  <Dropdown
                    id="CardAnesthesiaStatReportUX-Dropdown-28"
                    onChange={props.onHandleSelectReport}
                    options={props.reportOptions}
                    placeholder="เลือกประเภทรายงาน"
                    selection={true}
                    style={{width: "36rem"}}
                    value={props.onReportValue}>
                  </Dropdown>
                  <div
                    id="CardAnesthesiaStatReportUX-div-34">
                    {props.printButtonLoadCheck}
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </Form>
          <Table
            data={props.tableData}
            headers="วันที่เริ่มดมยา, เวลาเริ่มต้น, HN, ชื่อ-สกุล, อายุ(ปี), เพศ, สิทธิ, ASA, วิธีระงับความรู้สึก, วันที่สิ้นสุด, เวลาสิ้นสุด, ช่วงเวลาที่ใช้ดมยา, ประเภทเคส, ระดับความพึงพอใจ"
            id="CardAnesthesiaStatReportUX-Table-31"
            keys="anesDate, startTime, formatHn, patient_full_name, patient_age, patient_gender, payer, asa, anesMethod,  endDate, endTime, timeDuration, formatCase, formatSatisfaction"
            minRows="10"
            showPagination={false}>
          </Table>
        </div>
      </div>
    )
}


export default CardAnesthesiaStatReportUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", padding: \"1rem\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-div-1"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-Form-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-FormGroup-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-FormField-4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-FormField-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 7,
      "name": "DateTextBox",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-DateTextBox-7"
        },
        "onChange": {
          "type": "code",
          "value": "(date: string) => props.onHandleChangeDate(\"filterStartDate\", date)"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.startDate"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เริ่มดมยา"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-div-8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-FormField-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-div-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-FormField-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 12,
      "name": "DateTextBox",
      "parent": 15,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-DateTextBox-12"
        },
        "onChange": {
          "type": "code",
          "value": "(date: string) => props.onHandleChangeDate(\"filterEndDate\", date)"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.endDate"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-div-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-div-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-FormField-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-div-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-FormGroup-19"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"2rem 0rem 1rem 0rem\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-FormField-20"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-FormField-21"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", display: \"flex\", justifyContent: \"flex-start\", gap: \"1rem\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", display: \"flex\", justifyContent: \"flex-end\", gap: \"1rem\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "แสดงผลลัพธ์การค้นหา"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-label-24"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchCount"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-label-25"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", fontSize: \"22px\", color: \"darkcyan\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการ"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-label-26"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "label",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกประเภทสถิติ"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-label-27"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Dropdown",
      "parent": 23,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-Dropdown-28"
        },
        "onChange": {
          "type": "code",
          "value": "props.onHandleSelectReport"
        },
        "options": {
          "type": "code",
          "value": "props.reportOptions"
        },
        "placeholder": {
          "type": "value",
          "value": "เลือกประเภทรายงาน"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"36rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.onReportValue"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 31,
      "name": "Table",
      "parent": 1,
      "props": {
        "data": {
          "type": "code",
          "value": "props.tableData"
        },
        "headers": {
          "type": "value",
          "value": "วันที่เริ่มดมยา, เวลาเริ่มต้น, HN, ชื่อ-สกุล, อายุ(ปี), เพศ, สิทธิ, ASA, วิธีระงับความรู้สึก, วันที่สิ้นสุด, เวลาสิ้นสุด, ช่วงเวลาที่ใช้ดมยา, ประเภทเคส, ระดับความพึงพอใจ"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-Table-31"
        },
        "keys": {
          "type": "value",
          "value": "anesDate, startTime, formatHn, patient_full_name, patient_age, patient_gender, payer, asa, anesMethod,  endDate, endTime, timeDuration, formatCase, formatSatisfaction"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchButtonLoadCheck"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-div-32"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": "props.exportButtonLoadCheck"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-div-33"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "code",
          "value": "props.printButtonLoadCheck"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaStatReportUX-div-34"
        }
      },
      "seq": 34,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardAnesthesiaStatReportUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
